import { IRichText } from '@fdc/types/tiles-model';
import { useEffect, useRef } from 'react';

import styles from './rich-text.module.scss';

/** Render rich text.
 * Can handle both html from Admin Settings and Contentful Rich text.
 * Must be used with cleansed html. */
export const RichText = ({ heading, paragraph1, paragraph2 }: IRichText) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const content = heading.replace('<p>', '').replace('</p>', '');
  const parsedElements = new window.DOMParser()
    .parseFromString(content + paragraph1 + paragraph2, 'text/html')
    .querySelector('body').children;

  useEffect(() => {
    containerRef.current.innerHTML = ''; // Clear previous content
    containerRef.current.prepend(...parsedElements);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={containerRef} className={styles.richtext + ' richtext'}></div>
  );
};
